export default __webpack_public_path__ + "static/media/crm-hero.1d6f7a7e.svg";